export default __webpack_public_path__ + "static/anilPokhriyal5-9dc92656b788f95818f2ad7890d33846.jpg";